"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _react2 = require("@linaria/react");
var _core = require("@linaria/core");
var _modal = _interopRequireDefault(require("@ux/modal"));
var _patternLibraryUtils = require("@site/pattern-library-utils");
var _intents = _interopRequireDefault(require("@site/pattern-library-utils/intents"));
var _planBoxSectionSubscription = _interopRequireDefault(require("../../page-body/product-merchandising/plan-box-section-subscription"));
/* eslint-disable no-console */

// contribute one plan box styles back to Pattern Library
const modalFitAndPlanboxOverrides = "pl-m3qnbg8";
const planboxStyleOverrides = "pl-p1m7n03y";
const StyledPlanboxWrapper = /*#__PURE__*/(0, _react2.styled)("div")({
  name: "StyledPlanboxWrapper",
  class: "pl-sm4bds0"
});
function RecorePlanboxModal({
  headlineContent = '',
  cta,
  items,
  hasToggle,
  toggleLeftText,
  toggleRightText,
  toggleDisclaimer,
  onClose,
  ...modalProps
}) {
  (0, _patternLibraryUtils.useTracking)('recore-modal');
  const closeModal = () => {
    onClose && onClose();
  };
  const handleCloseClick = () => {
    (0, _patternLibraryUtils.logEvent)({
      eid: 'recore-modal-close',
      type: 'click'
    });
    closeModal();
  };
  return /*#__PURE__*/_react.default.createElement(_modal.default, (0, _extends2.default)({
    onClose: handleCloseClick,
    stretch: true,
    "data-cy": "recore-planbox-modal",
    className: items?.length === 1 ? modalFitAndPlanboxOverrides : planboxStyleOverrides
  }, modalProps), /*#__PURE__*/_react.default.createElement(_patternLibraryUtils.ModalPatch, null), /*#__PURE__*/_react.default.createElement(StyledPlanboxWrapper, {
    className: "fs-unmask"
  }, /*#__PURE__*/_react.default.createElement(_planBoxSectionSubscription.default, {
    _name: `planbox-subscription-${items[0]?.planType}`,
    headlineContent: headlineContent,
    cta: cta,
    items: items,
    hasToggle: hasToggle,
    toggleDisclaimer: toggleDisclaimer,
    toggleLeftText: toggleLeftText,
    toggleRightText: toggleRightText
  })));
}
RecorePlanboxModal.propTypes = {
  headlineContent: _propTypes.default.object,
  cta: _propTypes.default.object,
  items: _propTypes.default.arrayOf(_propTypes.default.shape({
    cta: _propTypes.default.object,
    planType: _propTypes.default.string,
    price: _propTypes.default.object,
    description: _propTypes.default.string
  })),
  hasToggle: _propTypes.default.bool,
  toggleDisclaimer: _propTypes.default.string,
  toggleLeftText: _propTypes.default.string,
  toggleRightText: _propTypes.default.string,
  domainCardProps: _propTypes.default.object,
  onClose: _propTypes.default.func,
  ..._modal.default.propTypes
};
var _default = exports.default = RecorePlanboxModal;